import { useState, useEffect } from "react";
import { usePhoneFactorSetupProxy } from "../Custom Hooks/usePhoneFactorSetupProxy";
import PhoneFactorTextMe from "../Components/PhoneFactorTextMe";
import PhoneFactorCallMe from "../Components/PhoneFactorCallMe";
import PhoneFactorMethodSelection from "../Components/PhoneFactorMethodSelection";
import { Flex } from "@chakra-ui/react";

export default function ConfirmPhoneFactor() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState("");

  const {
    sendCodeAction,
    callMeAction,
    verifyCodeAction,
    sendANewCodeAction,
    pageError,
    verificationCodeError,
  } = usePhoneFactorSetupProxy({ phoneNumber, verificationCode });

  const [phoneMethod, setPhoneMethod] = useState<string | null>(null);

  useEffect(() => {
    const savedPhoneNumber = sessionStorage.getItem('authex-registration-signup-mfa-phone-number');
    const savedPhoneMethod = sessionStorage.getItem('authex-registration-signup-mfa-phone-method');
    if (savedPhoneNumber == null || savedPhoneMethod == null) return;
    setPhoneNumber(savedPhoneNumber);
    setPhoneMethod(savedPhoneMethod);
    if (savedPhoneMethod === 'text') {
      setTimeout(() => sendCodeAction.act(), 100);
    } else if (savedPhoneMethod === 'call') {
      setTimeout(() => callMeAction.act(), 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const lastTwoDigits = phoneNumber.length === 10 ? phoneNumber.slice(8) : '';

  if (phoneMethod === '') {
    return <PhoneFactorMethodSelection
      pageError={pageError}
      setSelectedValue={setPhoneMethod}
      lastTwoDigits={lastTwoDigits}
      sendCodeAction={sendCodeAction}
      callMeAction={callMeAction}
      verificationCodeError={verificationCodeError}
    />;
  } else if (phoneMethod === 'text') {
    return <PhoneFactorTextMe
      lastTwoDigits={lastTwoDigits}
      pageError={pageError}
      verificationCodeError={verificationCodeError}
      verificationCode={verificationCode}
      verifyCodeAction={verifyCodeAction}
      sendANewCodeAction={sendANewCodeAction}
      setVerificationCode={setVerificationCode}
    />;
  } else if (phoneMethod === 'call') {
    return <PhoneFactorCallMe
      setSelectedValue={setPhoneMethod}
      verificationCodeError={verificationCodeError}
      lastTwoDigits={lastTwoDigits}
    />;
  }

  return (
    <Flex direction="column"  maxW={544} padding={38} justifyContent="center" mx="auto" data-testid="confirm-phone-factor-empty-test">
      <h1>Hello there it is working!</h1>
    </Flex>
  );
}
